
// import {getUUID} from 'src/common/js/utils';
import {
    loginFn
} from 'src/api/common.api.js';
import routes from 'src/router/index.js';
import {mapActions, mapGetters} from 'vuex';

export default {
    data () {
        var that = this,
            common = that.common,
            utilsObj = common.utils.utilsObj;

        var validateMobile = (rule, value, callback) => {
            if (!utilsObj.isMobile(value)) {
                callback(new Error('手机号格式错误'));
            } else {
                callback();
            }
        };

        return {
            dataForm: {
                username: '',
                password: '',
                uuid: '',
                captcha: ''
            },
            dataRule: {
                username: [
                    {required: true, message: '手机号不能为空', trigger: 'blur'},
                    {validator: validateMobile, trigger: 'blur'}
                ],
                password: [
                    {required: true, message: '密码不能为空', trigger: 'blur'}
                ],
                captcha: [
                    {required: true, message: '验证码不能为空', trigger: 'blur'}
                ]
            },
            captchaPath: '',
            hasChargingReality: false
        };
    },
    computed: {
        ...mapGetters([
            'getMenu'
        ])
    },
    created () {
        let that = this;
        let token = localStorage.getItem('token');

        that.getCaptcha();

        // 处理已经登录的时候直接跳转
        if (token) {
            let menuList = that.getMenu;
            let permsList = that.$store.state.permission;

            that.returnGoto(permsList, menuList);
        }
    },
    methods: {
        ...mapActions([
            'setPermission'
        ]),

        // 判断跳转到哪里
        returnGoto (permissionArr, routerArr) {
            let that = this;
            let hasChargingReality = permissionArr.some(str => str == 'gun:monitor:list');

            if (hasChargingReality) {
                that.$router.push({path: 'chargingReality'});
            } else {
                routerArr.forEach(item => {
                    if (item.children.length > 0) {
                        that.$router.push({path: routerArr[0].children[0].path});
                    }
                });
            }
        },

        /**
         * [loginSubmit 提交登录]
         * @return {[type]} [description]
         */
        loginSubmit: function () {
            let that = this,
                common = that.common,
                dataForm = that.dataForm,
                obj = {
                    username: dataForm.username,
                    password: dataForm.password,
                    uuid: dataForm.uuid,
                    captcha: dataForm.captcha
                };

            that.$refs['dataForm'].validate((valid) => {// 校验
                if (valid) {
                    that.common.serve.http.httpRequest(obj, loginFn, _cb);
                }
            });

            function _cb (res) {
                if (res.code === 0) {
                    if (res.user) {
                        localStorage.setItem('user', JSON.stringify(res.user || '{}'));
                    }

                    if (res.perms.length > 0) {
                        localStorage.setItem('perms', JSON.stringify(res.perms));
                        res.perms && Array.isArray(res.perms) && that.setPermission(res.perms);
                    }
                    localStorage.setItem('token', res.token);

                    // 登录的时候添加路由
                    routes.getMenu(function (route) {
                        for (let x of route) {
                            that.$router.addRoute(x);
                        }

                        that.returnGoto(res.perms, route);
                    });
                } else {
                    that.$message.error(res.msg);
                    // 登录异常更改uuid和验证图片
                    that.getCaptcha();
                }
            }
        },

        /**
         * [getCaptcha 获取验证码]
         * @return {[type]} [description]
         */
        getCaptcha () {
            let that = this,
                common = that.common;

            that.dataForm.uuid = common.utils.utilsObj.getUUID();
            that.captchaPath = common.serve.http.adornUrl(`/inc-charge/captcha.jpg?uuid=${that.dataForm.uuid}`);
        },

        /**
         * [openBeian 打开备案网站]
         * @return {[type]} [description]
         */
        openBeian () {
            let that = this;

            window.open('http://beian.miit.gov.cn/');
        }
    }
};


// WEBPACK FOOTER //
// ./src/views/common/login/login.js